import React from "react";

// Each `tab` is { key, label, ariaControls?, dataGuide?, disabled?,
// className?, attrs?, wrap? }. `className` and `attrs` (extra DOM props
// spread onto the button, e.g. drag-and-drop handlers) are optional —
// existing callers that don't set them are unaffected. `wrap` is an
// optional (button) => node, e.g. to put a tooltip around the whole button.
const SegmentedTabs = ({
	tabs = [],
	activeKey,
	onSelect,
	className = "",
	center = false,
	spacing = true,
	variant = "",
	ariaLabel = "Dashboard tabs",
}) => {
	return (
		<div
			className={`segmented-tabs${center ? " segmented-tabs--center" : ""}${
				spacing ? " segmented-tabs--spacing" : ""
			}${variant ? ` segmented-tabs--${variant}` : ""} ${className}`.trim()}
			role="tablist"
			aria-label={ariaLabel}>
			{tabs.map((tab) => {
				// Loose comparison: activeKey/tab.key are usually both numbers
				// or both strings already, but this tolerates either side
				// arriving as the other type without weakening the match for
				// existing (strict-typed) callers.
				const isActive = String(tab.key) === String(activeKey);

				const button = (
					<button
						type="button"
						key={tab.key}
						className={`segmented-tabs__item ${isActive ? "is-active" : ""}${
							tab.className ? ` ${tab.className}` : ""
						}`.trim()}
						role="tab"
						aria-selected={isActive}
						aria-controls={tab.ariaControls}
						data-guide={tab.dataGuide || undefined}
						onClick={() => onSelect && onSelect(tab.key)}
						disabled={tab.disabled}
						{...tab.attrs}>
						{tab.label}
					</button>
				);

				return tab.wrap ? (
					<React.Fragment key={tab.key}>{tab.wrap(button)}</React.Fragment>
				) : (
					button
				);
			})}
		</div>
	);
};

export default SegmentedTabs;
